var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoAddressIp = function SvgNoAddressIp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212.742,
    height: 269.605,
    viewBox: "0 0 212.742 269.605",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8264",
    "data-name": "Group 8264",
    transform: "translate(-310 -829.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8198",
    "data-name": "Group 8198",
    transform: "translate(310 829.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5639",
    "data-name": "Path 5639",
    d: "M80.832,146.782a54.059,54.059,0,1,1,63.894-63.9l29.44-29.44C159.231,21.831,128.011,0,91.791,0,41.093,0,0,42.657,0,95.269c0,23.361,18.083,60.275,38.2,94.136Z",
    transform: "translate(0)",
    fill: "#d0dded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5642",
    "data-name": "Path 5642",
    d: "M201.771,8.457a6.732,6.732,0,0,0-9.53,0l-188.7,188.7a6.739,6.739,0,1,0,9.53,9.53L43.861,175.9c20.415,31.812,38.95,56.42,38.937,56.507.984.5,91.791-121.709,91.791-174.328A99.019,99.019,0,0,0,173.76,46l28.011-28.011a6.732,6.732,0,0,0,0-9.53",
    transform: "translate(8.994 37.199)",
    fill: "#d0dded"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8265",
    "data-name": "Group 8265",
    transform: "translate(373.803 900.503)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3503",
    "data-name": "Rectangle 3503",
    width: 13,
    height: 21,
    rx: 6.5,
    transform: "translate(41.196 0.306)",
    fill: "#d0dded"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3504",
    "data-name": "Rectangle 3504",
    width: 13,
    height: 21,
    rx: 6.5,
    transform: "translate(0.196 0.306)",
    fill: "#d0dded"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5795",
    "data-name": "Path 5795",
    d: "M2.8,9.7A2.8,2.8,0,0,1,.462,5.361,12.463,12.463,0,0,1,10.868,0a12.475,12.475,0,0,1,10.4,5.356,2.8,2.8,0,1,1-4.681,3.078A6.819,6.819,0,0,0,10.868,5.6,6.835,6.835,0,0,0,5.14,8.437,2.8,2.8,0,0,1,2.8,9.7",
    transform: "translate(390.55 936.112)",
    fill: "#d0dded",
    stroke: "#d0dded",
    strokeWidth: 3
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoAddressIp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no_address_ip.79d7d65b.svg";
export { ForwardRef as ReactComponent };